import { combineReducers } from "@reduxjs/toolkit";
import station from "./reducers/stationReducer";
import customer from "./reducers/customerReducer";

export default combineReducers({
    station,
    customer,
});
